import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import ActionService from "../services/actions";
import { getSubdomain, showErrorMessage, showSuccessMessage } from "../../util/util";

const useActionHandler = ({ action, context, resModel, dataForm, refetch, submitForm, setOpenModalAction, closeModal }) => {
    const { t } = useTranslation();
    const hostname = window.location.hostname;
    const [loading, setLoading] = useState(false);
    const [modalAction, setModalAction] = useState({ status: false, id: null, res_model: null, views: null, display_name: "", res_id: null });

    const handleOpenNewPage = async ({ url }) => {
        if (!url) return showErrorMessage('No such URL');
        window.open(`${process.env.REACT_APP_DOMAIN}${url}&db=${getSubdomain(hostname)}`, '_blank')
    };

    const resultLoadAction = {
        "ir.actions.act_window": (params) => handleOpenModal(params),
        "ir.actions.server": (params) => handleRunAction(params),
        "ir.actions.act_url": ({ url }) => handleOpenNewPage({ url }),
        "ir.actions.act_window_close": (params) => closeModal()
    };

    const handleRunAction = async ({ actionId }) => {
        if (!actionId) return showErrorMessage('No such report');
        setLoading(true);
        try {
            const actionResponse = await ActionService.runAction({ idAction: actionId, idDetail: dataForm?.id, model: resModel });
            resultLoadAction[actionResponse?.result?.type]({ actionId, actionResult: actionResponse?.result, formValues: context, url: actionResponse?.url });
        } catch (err) {
            showErrorMessage(err?.message);
        } finally {
            setLoading(false);
        }
    };

    const callButton = useMutation({
        mutationFn: ({ method, resModel, ids, context }) => ActionService.callButton({
            method: method,
            resModel: resModel,
            ids: ids,
            context: context
        }),
        onSuccess: (data) => {
            if (!data || typeof data !== 'object' || !data?.type) {
                setLoading(false)
            } else {
                resultLoadAction[data?.type]({ actionId: dataForm?.id, actionResult: data, formValues: context, url: data?.url });
                setLoading(false)
            }
            return showSuccessMessage(`${action?.string} ${t('thành công')}`);
        },
        onError: () => {
            showErrorMessage(`${action?.string} ${t('thất bại')}`);
        }
    });

    const handleButtonObject = async () => {
        if (action?.confirm) {
        } else {
            setLoading(true)
            const responseSubmit = await submitForm(false)
            await callButton.mutateAsync({
                method: action?.name,
                resModel: resModel,
                ids: responseSubmit?.id ? [responseSubmit?.id] : [],
                context: {
                    ...context,
                    active_id: responseSubmit?.id,
                    active_ids: [responseSubmit?.id],
                    active_model: resModel
                }
            });
        }
    };

    const handleButtonAction = async (actionId) => {
        if (!actionId) return showErrorMessage('No such report');
        setLoading(true);
        try {
            const actionResponse = await ActionService.loadAction({ idAction: actionId, idDetail: dataForm?.id, model: resModel });
            resultLoadAction[actionResponse?.result?.type]({ actionId, actionResult: actionResponse?.result, formValues: context });
        } catch (err) {
            showErrorMessage(err?.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseActions = () => {
        setOpenModalAction(false)
        // setModalAction({ status: false, id: null, res_model: null, views: null, display_name: "", res_id: null });
    }

    const handleButton = async (actionId) => {
        if (action?.special === "cancel") {
            closeModal()
        } else {
            if (action?.type === 'object') {
                handleButtonObject();
            } else if (action?.type === 'action') {
                handleButtonAction(actionId);
            }
        }
    };

    return {
        loading,
        modalAction,
        handleButton,
        handleButtonAction,
        handleCloseActions
    };
};

export default useActionHandler;